import { useParams } from "@/components/hooks/use-params";
import { usePathname } from "@/components/hooks/use-pathname";
import { ListHeading } from "@/components/shared/list-header";
import { Redirect } from "@/components/shared/router";
import { View } from "@/components/ui";
import { AccountGiftCardHistory } from "@/containers/profile/account-gift-card/account-gift-card-history-component";
import { GiftCardHistoryFilter } from "@/containers/profile/account-gift-card/account-gift-card-history-component/gift-card-history-filter";
import { normalizeGiftCardTab } from "@/containers/profile/account-gift-card/account-gift-card-history-component/lib";

export const GiftCardHistory = () => {
  const { tab } = useParams<{ tab?: string | string[] }>();
  const activeTab = Array.isArray(tab) ? tab[0] : tab;
  const basePath = usePathname() || "/profile/gift-card";
  const normalizedTab = normalizeGiftCardTab(activeTab);

  if (!normalizedTab) {
    return <Redirect path={`${basePath}?tab=sent`} />;
  }

  return (
    <View className="flex flex-col">
      <View className="px-4 py-3">
        <ListHeading title="History" />
      </View>
      <GiftCardHistoryFilter basePath={basePath} activeTab={normalizedTab} />
      <AccountGiftCardHistory filter={{ tab: normalizedTab, limit: 4 }} />
    </View>
  );
};
